import React from "react";
import useVehicleModelDetails from 'client/hooks/queries/useVehicleModelDetails';
import { styled } from "@ff/ui";
import Box from "@ff/ui/Box";
import Text from "@ff/ui/Text";
import { colors } from "../typography";

interface ModelFeaturesProps {
  modelId?: number;
  features?: string[];
  align: 'left' | 'center' | 'right';
  color?: string;
  fontSize?: string;
}

export default function ModelFeatures(props: ModelFeaturesProps) {
  const { modelId, features=[], align, color, fontSize } = props
  const { vehicleModelDetails, loading: loadingVehicleModelDetails } =
    useVehicleModelDetails(modelId as number, {
      skip: !modelId || features.length > 0 
    });

  if(loadingVehicleModelDetails){
    return null; // we don't need to show loader icon in features 
  }
    
  if (features.length === 0) {
    if (vehicleModelDetails) {
      vehicleModelDetails.vehicleOverviewAssets.overviewFeatures.forEach(f => {
        features.push(f.title);
      });
    }else{
      return null;
    }
  }

  return (
    <Container align={align}>
      {features.map(feature => (
        <Feature key={feature} color={color} fontSize={fontSize}>{feature}</Feature>
      ))}
    </Container>
  );
}

const Container = styled(Box)<{align: string}>(({align}) => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: align === 'left' ? 'flex-start': align === 'center' ? 'center' : 'flex-end',
}));

const Feature = styled(Text)<{ color?: string, fontSize?: string }>(({ fontSize, color }) => ({
  fontSize: fontSize || '13px', 
  color: color || colors.content4,
  lineHeight: '24px',
}));